"use client";

import { Hourglass } from "lucide-react";
import { useEffect, useState } from "react";

export function AppDisableOverlay({ visible }: { visible: boolean }) {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    if (!visible) return;

    const interval = setInterval(() => {
      setRotation((prev) => (prev + 180) % 360);
    }, 1500);

    return () => clearInterval(interval);
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="relative flex size-40 items-center justify-center rounded-full bg-background/80 shadow-lg">
        <div className="absolute inset-0 animate-pulse rounded-full bg-gradient-to-tr from-primary/20 to-secondary/20" />
        <div
          className="relative z-10"
          style={{ transform: `rotate(${rotation}deg)`, transition: "transform 0.5s ease-in-out" }}
        >
          <Hourglass className="size-12 text-primary" />
        </div>
      </div>
      <div className="absolute inset-0 -z-10">
        <div className="absolute left-1/4 top-1/4 size-32 rounded-full bg-primary/20 blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 size-40 rounded-full bg-secondary/20 blur-3xl" />
      </div>
    </div>
  );
}
